'use client'

import { Provider as RollbarProvider, useRollbar } from '@rollbar/react'
import { useEffect } from 'react'
import type Rollbar from 'rollbar'
import { createClient } from '@/utils/supabase/client'

const rollbarConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN,
  environment: process.env.NODE_ENV ?? 'development',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? 'dev',
        guess_uncaught_frames: true,
      },
    },
  },
} as Rollbar.Configuration

function RollbarUserIdentifier() {
  const rollbar = useRollbar()

  useEffect(() => {
    const supabase = createClient()
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        rollbar.configure({
          payload: { person: { id: user.id, email: user.email } },
        })
      }
    })
  }, [rollbar])

  return null
}

export function RollbarClientProvider({ children }: { children: React.ReactNode }) {
  return (
    <RollbarProvider config={rollbarConfig}>
      <RollbarUserIdentifier />
      {children}
    </RollbarProvider>
  )
}
